import { TextZoom } from '@capacitor/text-zoom';
import { clamp } from 'lodash';

const setTextZoom = async (): Promise<void> => {
  try {
    const preferredSize = await TextZoom.getPreferred();
    const value = clamp(preferredSize.value, 1, 1.2);
    TextZoom.set({ value });
  } catch (e) {
    // do nothing if not implemented
  }
};

const isEqualIgnoreCase = (
  str1: string | null | undefined,
  str2: string | null | undefined
): boolean => {
  return str1?.toLowerCase() === str2?.toLowerCase();
};

export { setTextZoom, isEqualIgnoreCase };
